import { createReducer } from '@reduxjs/toolkit';
import { apiRequestFailed, apiRequestSuccess } from 'services/api/api.actions';
import { communityInfoUsersMeEndpoint } from './communityAccount.config';
import { GetCommunityInfoUsersMeResponse } from './communityAccount.types';

type CommunityAccountState = {
  communityAccountInfo: GetCommunityInfoUsersMeResponse | null;
};

const initialState: CommunityAccountState = {
  communityAccountInfo: null,
};

const communityAccountReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;

      if (payload.resourceId === communityInfoUsersMeEndpoint) {
        const response: GetCommunityInfoUsersMeResponse = payload.response.data;

        state.communityAccountInfo = response;
      }
    })
    .addCase(apiRequestFailed, (state, action) => {
      const { payload } = action;

      if (
        payload.resourceId === communityInfoUsersMeEndpoint &&
        payload.error?.response?.status === 404
      ) {
        state.communityAccountInfo = null;
      }
    }),
);

export default communityAccountReducer;
